function initMegaMenuV2Panels(menuDropdown) {
  const navItems = menuDropdown.querySelectorAll('.mega-menu-v2__nav-item');
  const panels = menuDropdown.querySelectorAll('.mega-menu-v2__panel');
  const panelsContainer = menuDropdown.querySelector('.mega-menu-v2__panels');

  if (!navItems.length) return;

  const activatePanel = (panelId) => {
    const activeNav = [...navItems].find((item) => item.dataset.panel === panelId);
    const isEmpty = activeNav?.dataset.panelEmpty === 'true';

    navItems.forEach((item) => {
      item.classList.toggle('is-active', item.dataset.panel === panelId);
    });
    panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.panel === panelId);
    });

    if (panelsContainer) {
      panelsContainer.classList.toggle('is-empty', Boolean(isEmpty));
    }
  };

  const firstPanelId = navItems[0]?.dataset.panel;
  if (firstPanelId) activatePanel(firstPanelId);

  navItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      if (item.dataset.panel) activatePanel(item.dataset.panel);
    });
    item.addEventListener('focus', () => {
      if (item.dataset.panel) activatePanel(item.dataset.panel);
    });
  });
}

class HeaderNewDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainView = this.querySelector('[data-view="main"]');
    this.subView = this.querySelector('[data-view="sub"]');
    this.subContent = this.querySelector('.header-new-drawer__sub-content');
    this.backBtn = this.querySelector('.header-new-drawer__back');
    this.footerMainBtns = this.querySelectorAll('[data-footer-view="main"]');
    this.footerCustomizeBtn = this.querySelector('.header-new-drawer__footer-btn--customize');
    this.footerSubBtn = this.querySelector('.header-new-drawer__footer-btn--sub');
    this.footerSubNote = this.querySelector('.header-new-drawer__footer-note[data-footer-view="sub"]');
    this.bindDrawerReset();
    this.bindEvents();
  }

  bindDrawerReset() {
    const drawerDetails = this.closest('.menu-drawer')?.closest('details');
    drawerDetails?.addEventListener('toggle', () => {
      if (!drawerDetails.open) this.closeSubView();
    });
  }

  bindEvents() {
    this.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-open-sub]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      this.openSubView(trigger.dataset.openSub, trigger.dataset.subTitle || '');
    });

    this.backBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.closeSubView();
    });
  }

  toggleFooter(view) {
    this.footerMainBtns.forEach((el) => el.classList.toggle('hidden', view !== 'main'));
    this.footerCustomizeBtn?.classList.toggle('hidden', view !== 'sub' || !this.footerCustomizeBtn?.dataset.hasContent);
    this.footerSubBtn?.classList.toggle('hidden', view !== 'sub' || !this.footerSubBtn?.dataset.hasContent);
    this.footerSubNote?.classList.toggle('hidden', view !== 'sub' || !this.footerSubNote?.textContent);
    this.querySelector('.header-new-drawer__footer')?.classList.toggle('hidden', view === 'none');
  }

  populateCustomizeBtn(btn, data) {
    if (!btn) return false;
    const hasCustomize = Boolean(data.customizeText);
    btn.dataset.hasContent = hasCustomize ? 'true' : '';
    if (!hasCustomize) {
      btn.textContent = '';
      btn.classList.add('hidden');
      return false;
    }
    btn.style.backgroundColor = data.customizeBg || '#F5F5F5';
    btn.style.color = data.customizeColor || '#202020';
    btn.innerHTML = '';
    if (data.customizeImg) {
      const img = document.createElement('img');
      img.src = data.customizeImg;
      img.alt = data.customizeText;
      img.loading = 'lazy';
      btn.appendChild(img);
    }
    btn.appendChild(document.createTextNode(data.customizeText));
    if (data.customizeLink) {
      btn.href = data.customizeLink;
      btn.removeAttribute('aria-disabled');
    } else {
      btn.removeAttribute('href');
      btn.setAttribute('aria-disabled', 'true');
    }
    return true;
  }

  populateSubBtn(btn, data) {
    if (!btn) return false;
    const hasSubFooter = Boolean(data.btnText);
    btn.dataset.hasContent = hasSubFooter ? 'true' : '';
    if (!hasSubFooter) {
      btn.textContent = '';
      btn.classList.add('hidden');
      return false;
    }
    btn.textContent = data.btnText;
    btn.style.backgroundColor = data.btnBg || '#173F2D';
    btn.style.color = data.btnColor || '#ffffff';
    if (data.btnLink) {
      btn.href = data.btnLink;
      btn.removeAttribute('aria-disabled');
    } else {
      btn.removeAttribute('href');
      btn.setAttribute('aria-disabled', 'true');
    }
    return true;
  }

  openSubView(templateId, title) {
    const template = document.getElementById(templateId);
    if (!template || !this.subContent) return;

    this.subContent.innerHTML = template.innerHTML;
    const backTitle = this.backBtn?.querySelector('.header-new-drawer__back-title');
    if (backTitle) backTitle.textContent = title;

    const footerData = template.dataset;
    const hasCustomize = this.populateCustomizeBtn(this.footerCustomizeBtn, footerData);
    const hasSubFooter = this.populateSubBtn(this.footerSubBtn, footerData);
    if (this.footerSubNote) {
      this.footerSubNote.textContent = footerData.btnNote || '';
    }

    this.toggleFooter(hasCustomize || hasSubFooter ? 'sub' : 'none');
    this.mainView?.classList.add('hidden');
    this.subView?.classList.remove('hidden');
  }

  closeSubView() {
    if (this.subContent) this.subContent.innerHTML = '';
    this.toggleFooter('main');
    this.subView?.classList.add('hidden');
    this.mainView?.classList.remove('hidden');
  }
}

if (!customElements.get('header-new-drawer')) {
  customElements.define('header-new-drawer', HeaderNewDrawer);
}

function initMegaMenuV2() {
  document.querySelectorAll('menu-dropdown.is-megamenu-v2').forEach(initMegaMenuV2Panels);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMegaMenuV2);
} else {
  initMegaMenuV2();
}
